export default __webpack_public_path__ + "fonts/chrome.svg";